@layer ch-tabular-grid {
  ch-tabular-grid-action-settings[disabled] {
    pointer-events: none;
  }
}